<template>
  <div class="head-page" style="padding-top: 90px;">
    <TradeHeader />
    <TradeHeader
      @child-event="toType"
      :name="symbolinfo.title"
      :num="symbolinfo.change"
      :title="symbolinfo.symbol"
    />
    <van-row class="trade-background">
      <van-col :span="12">
        
        <TradeModules
          ref="TradeModules"
          @change-trade="changeTradetype"
          @reset-record="resetRecord"
          :coinname="symbolinfo.coinname"
          :mPrice="priceinfo.close"
          :mid="symbolinfo.id"
        />
      </van-col>
      <van-col :span="12">
        <TradeData
          :symbol="symbolinfo.symbol"
          :tradetype="tradetype"
          :mPrice="priceinfo.close"
          @change-price="changePrice"
        />
      </van-col>
    </van-row>
    <TradeRecord ref="TradeRecord" />
    <Footer />
    <van-popup v-model="show" position="left">
      <TradeTypeList :datalst="dataLst" @change-item-event="changeItem" />
    </van-popup>
  </div>
</template>

<script>
import Footer from "@/components/Footer/index.vue";
import {
  TradeHeader,
  TradeModules,
  TradeData,
  TradeRecord,
  TradeTypeList
} from "./components/index";
export default {
  name: "TradeView",
  components: {
    Footer,
    TradeHeader,
    TradeModules,
    TradeData,
    TradeRecord,
    TradeTypeList,
  },
  data() {
    return {
      show: false,
      symbolinfo: {},
      timer: null,
      dataLst: [],
      tradetype: 0,
      priceinfo: {},
      currentSymbol: "",
      name: "",
      operation: 1
    };
  },
  mounted() {
    this.initPage()
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    initPage() {
      this.currentSymbol = this.$route.query.currentSymbol;
      this.name = this.$route.query.name;
      this.operation = this.$route.query.operation;
      if(this.operation){
        this.$refs.TradeModules.tradetype = this.operation
      }
      if (
        this.currentSymbol &&
        this.currentSymbol.length > 0 &&
        this.name &&
        this.name.length > 0
      ) {
        this.symbolinfo.symbol = this.currentSymbol;
      }
      this.getData();
      const that = this;
      this.$nextTick(() => {
        that.timer = setInterval(() => {
          that.getData();
        }, 1000);
      });
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getMarketList",
      }).then((res) => {
        if (res && res.data && res.data.list) {
          this.dataLst = res.data.list;
          if (this.dataLst && this.dataLst.length > 0) {
            if (!this.symbolinfo.symbol) {
              this.symbolinfo = this.dataLst[0];
            } else {
              this.dataLst.forEach((item) => {
                if (this.symbolinfo.symbol == item.symbol) {
                  this.symbolinfo = item;
                }
              });
            }
          }
        }
      });
    },
    toType() {
      this.show = true;
    },
    changeItem(val) {
      this.show = false;
      this.symbolinfo = val;
      if (this.timer) clearInterval(this.timer);
      this.getData();
      const that = this;
      this.$nextTick(() => {
        that.timer = setInterval(() => {
          that.getData();
        }, 1000);
      });
    },
    changeTradetype(val) {
      this.tradetype = val;
    },
    changePrice(val) {
      this.priceinfo = val;
    },
    resetRecord(val) {
      this.$refs.TradeRecord.ResetRecord(val);
    },
  },
};
</script>

<style>
</style>
